var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var ChapterIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 30,
    glyphHeight: 37
  }), React.createElement("path", {
    d: "M0.600037 19.2087C0.600037 7.31307 6.65221 0.843506 16.0435 0.843506C22.5131 0.843506 26.4783 3.34785 29.1913 8.98264L22.7218 12.3218C21.887 9.40003 20.0087 7.52177 16.2522 7.52177C11.8696 7.52177 8.73917 10.4435 8.73917 16.0783V21.7131C8.73917 27.1392 11.6609 30.2696 16.2522 30.2696C20.0087 30.2696 22.0957 27.9739 23.1392 25.0522L29.4 28.6C26.8957 33.8174 22.7218 36.9479 16.2522 36.9479C6.65221 36.9479 0.600037 30.8957 0.600037 19.2087Z"
  }));
};
export var ChapterIconGlyph = function (props) {
  return React.createElement(ChapterIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};